import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { RouterService } from 'core/services/router.service';
import { StorageService } from 'core/services/storage.service';

export const AuthGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const routerService = inject(RouterService);
  
  const { isAuthenticated } = storageService;

  if (!isAuthenticated) {
    storageService.clearStorage();
    routerService.goToLogin();
    return false;
  }

  return true;
};